import DiamondIcon from "assets/icons/diamond.svg?react";
import ArrowIcon from "assets/icons/banger/arrow-right.svg?react";

import "./styles.sass";
import { useNavigate } from "react-router-dom";
import url from "url/index";
import { makeLangUrl } from "../../../helpers/makeLangUrl";

const LoyaltyButton = () => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const navigate = useNavigate();
  return (
    <div
      className="LoyaltyButton"
      onClick={() =>
        navigate(
          makeLangUrl(
            `${url.config.profile.root}/${url.config.profile.loyaltyProgram.root}`,
          ),
        )
      }
    >
      <div>
        <DiamondIcon />
      </div>
      {VITE_APP_PROJECT_NAME === "banger" ? "BANGER" : "GLORY"} CLUB
      <div>
        <ArrowIcon />
      </div>
    </div>
  );
};

export default LoyaltyButton;
